// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: AyxmFR8Hah1Q
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import Button from "../../Button"; // plasmic-import: CLyiSGaOpklv/component
import RolesCard from "../../RolesCard"; // plasmic-import: iBncYn8g8dso/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicRoles.module.css"; // plasmic-import: AyxmFR8Hah1Q/css

createPlasmicElementProxy;

export const PlasmicRoles__VariantProps = new Array();

export const PlasmicRoles__ArgProps = new Array();

const $$ = {};

function PlasmicRoles__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__lXoZq)}>
            <Sidebar
              data-plasmic-name={"sidebar"}
              data-plasmic-override={overrides.sidebar}
              className={classNames("__wab_instance", sty.sidebar)}
            />

            <div className={classNames(projectcss.all, sty.freeBox___9Sry9)}>
              <div className={classNames(projectcss.all, sty.freeBox__nhJNs)}>
                <div className={classNames(projectcss.all, sty.freeBox__icpjw)}>
                  <div
                    data-plasmic-name={"text"}
                    data-plasmic-override={overrides.text}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text
                    )}
                  >
                    <React.Fragment>
                      <React.Fragment>{""}</React.Fragment>
                      {
                        <h4
                          data-plasmic-name={"h4"}
                          data-plasmic-override={overrides.h4}
                          className={classNames(
                            projectcss.all,
                            projectcss.h4,
                            projectcss.__wab_text,
                            sty.h4
                          )}
                        >
                          {"Roles List"}
                        </h4>
                      }

                      <React.Fragment>{""}</React.Fragment>
                    </React.Fragment>
                  </div>
                  <Button
                    data-plasmic-name={"addRoleBtn"}
                    data-plasmic-override={overrides.addRoleBtn}
                    className={classNames("__wab_instance", sty.addRoleBtn)}
                  >
                    {"Add Role"}
                  </Button>
                </div>
                <div
                  data-plasmic-name={"rolesListStack"}
                  data-plasmic-override={overrides.rolesListStack}
                  className={classNames(projectcss.all, sty.rolesListStack)}
                >
                  <RolesCard
                    data-plasmic-name={"rolesCard"}
                    data-plasmic-override={overrides.rolesCard}
                    className={classNames("__wab_instance", sty.rolesCard)}
                    roleName={"Admin"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "text",
    "h4",
    "addRoleBtn",
    "rolesListStack",
    "rolesCard"
  ],

  sidebar: ["sidebar"],
  text: ["text", "h4"],
  h4: ["h4"],
  addRoleBtn: ["addRoleBtn"],
  rolesListStack: ["rolesListStack", "rolesCard"],
  rolesCard: ["rolesCard"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicRoles__ArgProps,
          internalVariantPropNames: PlasmicRoles__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicRoles__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicRoles";
  } else {
    func.displayName = `PlasmicRoles.${nodeName}`;
  }
  return func;
}

export const PlasmicRoles = Object.assign(
  // Top-level PlasmicRoles renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    text: makeNodeComponent("text"),
    h4: makeNodeComponent("h4"),
    addRoleBtn: makeNodeComponent("addRoleBtn"),
    rolesListStack: makeNodeComponent("rolesListStack"),
    rolesCard: makeNodeComponent("rolesCard"),
    // Metadata about props expected for PlasmicRoles
    internalVariantProps: PlasmicRoles__VariantProps,
    internalArgProps: PlasmicRoles__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicRoles;
/* prettier-ignore-end */
